var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{attrs:{"type":"number"},on:{"change":function($event){return _vm.addPlayerRes({
                        id:_vm.$props.id,
                        user_id:_vm.$props.user_id,
                        team_id:_vm.$props.team_id,
                        match_id:_vm.$props.match_id,
                      })}},model:{value:(_vm.killPts),callback:function ($$v) {_vm.killPts=$$v},expression:"killPts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }